module.exports = __webpack_public_path__ + "img/50.3e574804.png";